import { BRAND } from "constants/brand";
import { Ring } from "@uiball/loaders";
import "assets/styles/table.scss";
import { useState, useRef, useEffect } from "react";
import { Toast } from "primereact/toast";
import DeleteItem from "components/Ui/DeleteItem/DeleteItem";
import Category from "./Category/Category";
import AddOptions from "./AddOptions/AddOptions";
import EditOptions from "./EditOptions/EditOptions";
import useGroups from "hooks/useGroups";
import TableColumnsMenu from "components/Ui/TableColumnsMenu/TableColumnsMenu";
import TableHead from "components/Ui/TableHead/TableHead";
import useTableColumnsConfig from "hooks/useTableColumnsConfig";

const COLUMNS = [
    { id: "id", label: "رقم الاضافه", width: "10px" },
    { id: "name", label: "الاسم", width: "100px" },
    { id: "type", label: "النوع", width: "100px" },
    { id: "options", label: "الخيارات", width: "100px" },
    { id: "actions", label: "الاعدادات", width: "50px" },
];

const Groups = () => {
    const [showAddForm, setShowAddForm] = useState(false);
    const [showEditForm, setShowEditForm] = useState(false);
    const [showDelete, setShowDelete] = useState(false);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const { loading, editOption, deleteOption, fetchOptions, options } = useGroups();
    const toast = useRef(null);
    const { orderedColumns, visibleColumns, hiddenSet, toggleColumn, moveColumn, reset } =
        useTableColumnsConfig("groups", COLUMNS);

    useEffect(() => {
        fetchOptions();
    }, []);

    const showMessage = (type, head, content) => {
        toast.current.show({
            severity: type,
            summary: head,
            detail: content,
            life: 3000,
        });
    };

    const toggleAddForm = () => {
        setShowAddForm((pre) => (pre = !pre));
    };

    const toggleEditForm = () => {
        setShowEditForm((pre) => (pre = !pre));
    };

    const setSelectedCategoryValue = (category) => {
        setSelectedCategory(category);
    };

    const toggleDelete = () => {
        setShowDelete((pre) => (pre = !pre));
    };

    const confirmDelete = async () => {
        try {
            const response = await deleteOption(selectedCategory.id);
            // Assuming `response` contains information to check if the operation succeeded

            if (response) {
                showMessage("warn", "تم الحذف", "تم حذف الاضافه بنجاح");
                toggleDelete();
            } else {
                showMessage("error", "هناك خطأ", "حدث خطأ غير متوقع");
            }
        } catch (err) {
            console.error("Error adding vendor:", err);
            showMessage("error", "هناك خطأ", "حدث خطأ غير متوقع");
        }
    };

    return (
        <div className="items">
            <Toast style={{ direction: "rtl" }} ref={toast} position="top-left" />

            {loading ? (
                <div className="loadingSpinner">
                    <Ring size={40} lineWeight={5} speed={2} color={BRAND} />
                </div>
            ) : (
                <>
                    <div className="controls">
                        <div>
                            <button className="button" onClick={toggleAddForm}>
                                إضافه
                            </button>
                        </div>
                        <div style={{ marginInlineStart: "auto" }}>
                            <TableColumnsMenu
                                orderedColumns={orderedColumns}
                                hiddenSet={hiddenSet}
                                toggleColumn={toggleColumn}
                                moveColumn={moveColumn}
                                reset={reset}
                            />
                        </div>
                    </div>
                    <div className="table-container">
                        <table>
                            <TableHead visibleColumns={visibleColumns} />
                            <tbody>
                                {options ? (
                                    options.map((group) => (
                                        <Category
                                            key={group.id}
                                            group={group}
                                            visibleColumns={visibleColumns}
                                            editCategory={editOption}
                                            selectedCategory={selectedCategory}
                                            toggleEditForm={toggleEditForm}
                                            setSelectedgroupValue={setSelectedCategoryValue}
                                            toggleDelete={toggleDelete}
                                        />
                                    ))
                                ) : (
                                    <h4>لا يوجد اضافات!</h4>
                                )}
                            </tbody>
                        </table>
                    </div>
                    {/* <Stack spacing={1}>
            <Pagination
              count={pages}
              defaultPage={page}
              shape="rounded"
              color={BRAND}
              style={{ margin: "20px auto 0" }}
              onChange={handleChangePage}
            />
          </Stack> */}
                    <AddOptions
                        show={showAddForm}
                        close={toggleAddForm}
                        showMessage={showMessage}
                    />
                    <EditOptions
                        show={showEditForm}
                        close={toggleEditForm}
                        showMessage={showMessage}
                        group={selectedCategory}
                    />
                    <DeleteItem
                        show={showDelete}
                        close={toggleDelete}
                        loading={loading}
                        confirm={confirmDelete}
                    />
                </>
            )}
        </div>
    );
};
export default Groups;
